import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import './App.css';

import Home from './home/index'

const App = () => {
    return (

        <BrowserRouter>
            <Switch>
                <Route 
                    path = "/" 
                    exact
                    component = { Home } 
                />
            </Switch>
        </BrowserRouter>
        
    );
}

export default App;